<div class="wrapper-oders-cod">
  <div class="section-title row">
    <div class="section-btn">
      <button
        routerLink="/dashboard/orders"
        class="btn btn-back" [attr.aria-label]="'Back' | translate">
        <i class="fi-rr-arrow-alt-left"></i>
      </button>
    </div>
    <div>
      <div class="title" [attr.data-parent]="'Orders' | translate">{{'Orders' | translate}}</div>
    </div>
    <div class="d-inline-block w-100">
      <button
        *ngIf="selectedFilter === 'Approve' || selectedFilter ==='Cancel' && remark !='' "
        class="btn btn-outline-primary"
        [disabled] = "loadingInfo"
        (click)="saveCod(selectedFilter)"
      >
      {{'Save' | translate}}
      </button>
    </div>
  </div>

  <div class="section-main">
    <mat-tab-group animationDuration="0ms" [disableRipple]="true" dynamicHeight #tabGroup>
      <mat-tab label="{{'Customer' | translate}}">
          <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12" style="margin-bottom: 10px; margin-top: 20px;">
            <div class="card h-3 mt-25">
              <h4 class="title">{{'Order Detail' | translate}}</h4>
              <div class="row">
                <div class="col-4">
                  <div class="title-2">{{'Delivery Details' | translate}} :</div>
                </div>
                <div class="col-8">
                  <p class="font-weight-bold mb-0 uppercase fs-14">{{ codData.receiver_name }}</p>
                  <p class="mb-0">{{ codData.receiver_address }}</p>
                  <p class="mb-0">{{ codData.receiver_city }}</p>
                  <p class="mt-2">
                    <a href="tel:{{ codData.receiver_mobile }}">{{
                      codData.receiver_mobile
                    }}</a>
                  </p>
                </div>
              </div>
              <h4 class="title">{{'Courier Details' | translate}}</h4>
              <div class="row">
                <div class="col-4">
                  <div class="title-2">{{'Courier Name' | translate}} :</div>
                  <div class="title-2">{{'Courier Charges' | translate}} :</div>
                </div>
                <div class="col-8">
                  <p class="mb-0">
                    {{ codData.courier_name }}
                  </p>
                  <p class="mb-0">
                    {{ codData.currency }}
                    {{ codData.courier_charges }}
                  </p>
                </div>
              </div>
            </div>
          </div>
      </mat-tab>

      <mat-tab label="{{'Product' | translate}}">
          <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12" style="margin-bottom: 10px; margin-top: 20px;">
            <div class="card h-3 mt-25">
              <!-- <h4 class="title">Product Details</h4> -->
              <div
                class="product"
                *ngFor="
                  let item of codData?.fiv5s_order_response
                    ?.order_detail ||
                    codData?.order_details ||
                    []; let i = index
                "
              >
                <div class="row align-items-center">
                  <div class="col-auto">
                    <div class="order-image-container">
                      <img src="{{ item.data.image }}" class="order-image ml-2" />
                    </div>
                  </div>
                  <div class="col">
                    {{ item.data.product_name }}
                  </div>
                  <div *ngIf="codData.payment_status === '2' && codData.payment_type ==='cod' ">
                    <div class="button-wrapper" *ngIf="item.mixture_product != undefined">
                      <input type="number" min="1" max="{{ item.data.max_qty_per_order }}" disabled="disabled" class="num" value="{{value}}" [(ngModel)]="value[i]"/>
                    </div>
                    <div class="button-wrapper" *ngIf="item.mixture_product === undefined">
                      <button class="plusminus" (click)="handleMinus(i,item.data.product_id)" [disabled]="value[i] <=1">-</button>
                      <input type="number" min="1" max="{{ item.data.max_qty_per_order }}" disabled="disabled" class="num" value="{{value}}" [(ngModel)]="value[i]"/>
                      <button class="plusminus" (click)="handlePlus(i,item.data.product_id)" [disabled]="value[i] ===item.data.max_qty_per_order">+</button>
                    </div>
                  </div>
                  <div *ngIf="codData.payment_status != '2' && codData.payment_type !='cod' ">
                  <div class="col-2 product-qty">
                    &times; {{ item.data.quantity }}
                  </div>
                  </div>
                  <div class="col-3 product-price">
                    <span class="mr-2" *ngIf="+item.data.price !== 0"
                      >{{ item.data.currency }}
                      {{item.data.retail_price[value[i]] !== undefined ? +item.data.retail_price[value[i]]  : item.data.retail_price[1] * value[i] | number}}</span
                    >
                    <span class="mr-2" *ngIf="+item.data.price === 0"> {{'Free' | translate}} </span>
                  </div>
                </div>
                <div class="row">
                  <p class="mb-2"></p>
                  <div
                    *ngIf="item.mixture_product !== undefined"
                    class="mixture-container"
                  >
                    <h3>Mixture</h3>
                    <ul class="mixture-list">
                      <li
                        *ngFor="let mixture_product of item.mixture_product"
                        class="col-auto mixture-list-item"
                      >
                        <div class="row align-items-center">
                          <div class="col-auto mixture-item-image">
                            <img
                              [src]="mixture_product?.data?.image"
                              onerror="this.onerror=null;this.src='https://cdn.estore5s.com/asset/images/estore_missing_product.png';"
                            />
                          </div>
                          <div class="col">
                            {{ mixture_product?.data?.product_name }}
                          </div>
                          <div class="col-2"></div>
                          <div class="col-3 mixture-qty">
                            &times;
                            {{ mixtureqty}}
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
      </mat-tab>

      <mat-tab label="{{'Order Statuses' | translate}}">
            <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12" style="margin-bottom: 10px; margin-top: 20px;">
              <div *ngIf="loadingInfo" class="text-center">
                <div class="loading-spinner col-12">
                  <mat-spinner
                    class="mx-auto my-3"
                    [diameter]="50"
                  ></mat-spinner>
                </div>
              </div>
                <div class="card h-3 mt-25" *ngIf="!loadingInfo">
                  <div class="row">
                  <div class="col" style="margin-bottom: 30px ;">
                    <div ngbDropdown class="d-inline-block w-30">
                      <button
                        class="btn btn-outline-primary"
                        id="dropdownBasic1"
                        ngbDropdownToggle
                      >
                      {{ '{0}' | translate:[ utils.translate(selectedStatus || "Status")] }}
                      </button>
                      <div
                        ngbDropdownMenu
                        aria-labelledby="dropdownBasic1"
                        class="custom-dropdown"
                      >
                        <button
                          ngbDropdownItem
                          *ngFor="let filter of statusFilters"
                          (click)="selectedStatus = filter"
                          (click)="selectedStatusclick(filter)"
                        >
                        {{ '{0}' | translate:[ utils.translate(filter)] }}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                  <div class="row">

                    <div class="col">
                      <div *ngIf="selectedFilter === 'Cancel'">
                        <div class="title-2">{{'Reason for cancellation of order' | translate}} :</div>
                        <textarea [(ngModel)]="remark" placeholder="{{'Please enter reason for cancellation' | translate}}" ></textarea>
                        <div style="font-size: 0.8rem; margin-bottom: 30px;">{{'This reason will be send to the customer.' | translate}}</div>
                      </div>
                    </div>
                  </div>
                  <h4 class="title">{{'Order Detail' | translate}}</h4>
                  <div class="row">
                    <div class="col-4">
                      <div class="title-2">{{'Delivery Details' | translate}} :</div>
                    </div>
                    <div class="col-8">
                      <p class="font-weight-bold mb-0 uppercase fs-14">{{ codData.receiver_name }}</p>
                      <p class="mb-0">{{ codData.receiver_address }}</p>
                      <p class="mb-0">{{ codData.receiver_city }}</p>
                      <p class="mt-2">
                        <a href="tel:{{ codData.receiver_mobile }}">{{
                          codData.receiver_mobile
                        }}</a>
                      </p>
                    </div>
                  </div>
                  <h4 class="title">{{'Courier Details' | translate}}</h4>
                  <div class="row" style="margin-bottom: 30px;">
                    <div class="col-4">
                      <div class="title-2">{{'Courier Name' | translate}} :</div>
                      <div class="title-2">{{'Courier Charges' | translate}} :</div>
                    </div>
                    <div class="col-8">
                      <p class="mb-0">
                        {{ codData.courier_name }}
                      </p>
                      <p class="mb-0">
                        {{ codData.currency }}
                        {{ codData.courier_charges }}
                      </p>
                    </div>
                  </div>



                    <h4 class="title">{{'Product Details' | translate}}</h4>
                    <div
                      class="product"
                      *ngFor="
                        let item of codData?.fiv5s_order_response
                          ?.order_detail ||
                          codData?.order_details ||
                          []; let i = index
                      "
                    >
                      <div class="row align-items-center">
                        <div class="col-auto">
                          <div class="order-image-container">
                            <img src="{{ item.data.image }}" class="order-image ml-2" />
                          </div>
                        </div>
                        <div class="col">
                          {{ item.data.product_name }}
                        </div>
                        <div class="col-2 product-qty">
                          &times; {{ value[i]}}
                        </div>
                        <div class="col-3 product-price">
                          <span class="mr-2" *ngIf="+item.data.price !== 0"
                            >{{ item.data.currency }}
                            {{item.data.retail_price[value[i]] !== undefined ? +item.data.retail_price[value[i]]  : item.data.retail_price[1] * value[i] | number}}</span
                          >
                          <span class="mr-2" *ngIf="+item.data.price === 0"> Free </span>
                        </div>
                      </div>
                      <div class="row">
                        <p class="mb-2"></p>
                        <div
                          *ngIf="item.mixture_product !== undefined"
                          class="mixture-container"
                        >
                          <h3>Mixture</h3>
                          <ul class="mixture-list">
                            <li
                              *ngFor="let mixture_product of item.mixture_product"
                              class="col-auto mixture-list-item"
                            >
                              <div class="row align-items-center">
                                <div class="col-auto mixture-item-image">
                                  <img
                                    [src]="mixture_product?.data?.image"
                                    onerror="this.onerror=null;this.src='https://cdn.estore5s.com/asset/images/estore_missing_product.png';"
                                  />
                                </div>
                                <div class="col">
                                  {{ mixture_product?.data?.product_name }}
                                </div>
                                <div class="col-2"></div>
                                <div class="col-3 mixture-qty">
                                  &times;
                                  {{ mixtureqty }}
                                </div>
                              </div>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
              </div>

        </mat-tab>

    </mat-tab-group>
</div>

</div>

<ng-template #success let-modal>
  <div class="modal-body text-center">
      <div class="row" align="center">
          <div class="col pt-4 pt-lg-0">
              <h4>{{this.errorMsg}}</h4>
          </div>
      </div>
      <button class="btn btn-primary" type="button" name="button" (click)="modal.close('Send click')  ">Close</button>
  </div>
</ng-template>
